<template>
    <div class="congress-schedule-day">
        <!-- Committee Header: Name + Display Style -->
        <div class="congress-schedule-day-header">
            <!-- Name -->
            <div class="congress-schedule-day-header-date-label" style="flex: 2">
                <Field
                    v-model="committee.name"
                    label-position="none"
                    :field="{
                        name: lang('congresses::congresses.committees.name'),
                        slug: `committees.${committeeIndex}.name`,
                        type: 'text',
                        adminComponent: 'AdminText',
                        required: true,
                        placeholder: lang('congresses::congresses.committees.name_placeholder'),
                    }"
                />
            </div>

            <!-- Display Style -->
            <div class="congress-schedule-day-header-date">
                <Field
                    v-model="committee.display_style"
                    label-position="none"
                    :field="{
                        name: lang('congresses::congresses.committees.display_style'),
                        slug: `committees.${committeeIndex}.display_style`,
                        type: 'select',
                        adminComponent: 'AdminSelect',
                        portal: true,
                        options: displayStyleOptions,
                    }"
                />
            </div>

            <!-- Remove button -->
            <div class="congress-schedule-day-header-actions">
                <Button type="button" size="sm" color="secondary" variant="inline" @click="$emit('remove')">
                    <span class="action-icon">
                        <Icon icon="phosphor/regular/trash"></Icon>
                    </span>
                    <span class="action-label">
                        {{ lang('congresses::congresses.committees.remove') }}
                    </span>
                </Button>
            </div>
        </div>

        <!-- Members list -->
        <CommitteeMemberList v-model="committee.members" :committee-index="committeeIndex" />
    </div>
</template>

<script setup lang="ts">
import { lang } from '@/lang/composable';
import Button from '@src/Common/Components/Button.vue';
import Field from '@src/Common/Components/Field.vue';
import CommitteeMemberList from './CommitteeMemberList.vue';
import type { Committee } from '../types';

defineProps<{
    committeeIndex: number;
}>();

defineEmits<{
    (e: 'remove'): void;
}>();

const committee = defineModel<Committee>();

const displayStyleOptions = [
    { id: 'default', name: lang('congresses::congresses.committees.display_style_default') },
    { id: 'compact', name: lang('congresses::congresses.committees.display_style_compact') },
];
</script>
